import { Component, DoCheck, Input, IterableDiffer, IterableDiffers, OnInit } from '@angular/core';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';
import { DeviceStatusViewInfoService } from '../shared/services/device-status-view-info.service';

@Component({
    selector: 'dl-device-reader-status',
    templateUrl: './device-reader-status.component.html',
    styleUrls: ['./device-reader-status.component.scss']
})
export class DeviceReaderStatusComponent implements DoCheck, OnInit {
    public static $name: string = 'deviceReaderStatus';

    @Input() public item: IDeviceStatusListSummary;
    public textAccentClass: string;

    private iterableDiffer: IterableDiffer<any>;

    constructor(
        protected deviceStatusViewInfoService: DeviceStatusViewInfoService,
        private iterableDiffers: IterableDiffers,
        private themeService: ThemeService
    ) {
        this.iterableDiffer = this.iterableDiffers.find([]).create(null);
        this.textAccentClass = this.themeService.getTextAccentClass();
    }

    public ngDoCheck() {
        let changes = this.iterableDiffer.diff(this.item.componentStatuses);

        if (changes) {
            this.initStatus();
        }
    }

    public ngOnInit() {
        this.initStatus();
    }

    private initStatus() {
        for (const status of this.item.componentStatuses) {
            status.$status = this.deviceStatusViewInfoService.getState(status.status, false);
        }
    }

}
